import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {Text} from '../../../design-system/atoms/Text/Text';
import {LinedTable} from '../../../design-system/organisms/LinedTable/LinedTable';
import {RefundableAmountInfoProps} from '../../credit-refund/request/type';

export function RefundableAmountInfo({
  refundableAmount,
  refundCreditInfoRowList,
  className,
  ...props
}: RefundableAmountInfoProps) {
  return (
    <div className={className} {...props}>
      <div>
        <Text className="font-medium1-bold text-theme-solid-100">
          {t('more_customer_cash_refund_amount')}
        </Text>
        <Text className="font-medium1-bold ml-4px text-theme-solid-100">
          {t('more_customer_cash_refund_amount_kr', {
            values: {
              value: formatWithCommas(refundableAmount),
            },
          })}
        </Text>
      </div>
      <LinedTable
        className="mt-16px w-full"
        rowList={refundCreditInfoRowList}
      />
      <Text className="font-small2 mt-16px block text-theme-solid-60">
        <Text className="mr-4px">·</Text>
        {t('more_customer_cash_refund_guide_1')}
        <br />
        <Text className="mr-4px">·</Text>
        {t('more_customer_cash_refund_guide_2')}
        <br />
        <Text className="mr-4px">·</Text>
        {t('more_customer_cash_refund_guide_3')}
        <br />
      </Text>
    </div>
  );
}
